
import React from 'react';

export const MarketCoverageSection: React.FC = () => {
  const majorMarkets = [
    'New York, NY', 'Los Angeles, CA', 'Chicago, IL', 'Houston, TX',
    'Phoenix, AZ', 'Philadelphia, PA', 'San Antonio, TX', 'San Diego, CA',
    'Dallas, TX', 'San Jose, CA', 'Austin, TX', 'Jacksonville, FL',
    'Fort Worth, TX', 'Columbus, OH', 'Charlotte, NC', 'San Francisco, CA',
    'Indianapolis, IN', 'Seattle, WA', 'Denver, CO', 'Washington, DC'
  ];

  return (
    <section className="py-20 bg-navy-900" style={{ backgroundColor: '#1A2B4A' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              NATIONWIDE COVERAGE
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Serving Multifamily Sellers <br />
              Across America
            </h2>
            
            <p className="text-xl text-gray-300 leading-relaxed mb-8">
              We have a nationwide network of cash buyers and investors ready to purchase 
              multifamily properties in all 50 states. Our local market expertise ensures 
              you get the best possible offer for your commercial building or apartment complex.
            </p>

            <div className="grid md:grid-cols-2 gap-4">
              <h3 className="text-lg font-semibold text-white mb-4 md:col-span-2">
                Top Markets We Serve:
              </h3>
              
              {majorMarkets.slice(0, 10).map((market, index) => (
                <div key={index} className="flex items-center text-gray-300">
                  <i className="ri-checkbox-circle-fill text-orange-500 mr-3"></i>
                  <span>{market}</span>
                </div>
              ))}
              
              {majorMarkets.slice(10).map((market, index) => (
                <div key={index + 10} className="flex items-center text-gray-300">
                  <i className="ri-checkbox-circle-fill text-orange-500 mr-3"></i>
                  <span>{market}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Map Visual */}
          <div className="relative">
            <div className="bg-gradient-to-br from-orange-500/20 to-orange-600/30 rounded-2xl p-8 backdrop-blur-sm">
              <div className="text-center">
                <div className="w-64 h-48 mx-auto relative">
                  {/* Simplified US Map Representation */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="relative">
                      <i className="ri-map-2-fill text-orange-500 text-9xl opacity-80"></i>
                      
                      {/* Glowing Dots for Major Markets */}
                      <div className="absolute top-4 left-8 w-3 h-3 bg-orange-400 rounded-full animate-pulse"></div>
                      <div className="absolute top-6 right-12 w-3 h-3 bg-orange-400 rounded-full animate-pulse"></div>
                      <div className="absolute bottom-8 left-16 w-3 h-3 bg-orange-400 rounded-full animate-pulse"></div>
                      <div className="absolute bottom-12 right-8 w-3 h-3 bg-orange-400 rounded-full animate-pulse"></div>
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 bg-orange-400 rounded-full animate-pulse"></div>
                    </div>
                  </div>
                </div>
                
                <div className="mt-6 grid grid-cols-2 gap-6">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-white mb-2">50</div>
                    <div className="text-gray-300">States Covered</div>
                  </div>
                  
                  <div className="text-center">
                    <div className="text-3xl font-bold text-white mb-2">500+</div>
                    <div className="text-gray-300">Cities Served</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
